import allCombos from '@/helpers/allCombos.json'

const eq_chart_mix = {
  data() {
    return {
      showTooltip: false,
    }
  },
  methods: {
    getPlayerPoints(player, ppPos, rangeKey) {
      if (this.simpleView) {
        return this.getPointsFromPlayer(player)
      }
      return this.getPointsFromHands(player, ppPos, rangeKey)
    },
    getPointsFromPlayer(player) {
      const playerInfo = this.players[player]
      if (!playerInfo) return []

      const { hand_eqs: eqs = [], eq_percentile: percentiles = [] } = playerInfo
      return eqs
        .map((eq, idx) => ({
          x: percentiles[idx],
          y: 1 - eq,
          eq,
          hand: allCombos[idx],
          ppPos: playerInfo.relative_postflop_position,
          player,
          circle_size: 1,
        }))
        .filter(point => point.x >= 0)
        .sort((a, b) => a.x - b.x)
        .map((point, idx, arr) => {
          if (idx === arr.length - 1) point.x = 1
          return point
        })
    },
    getPointsFromHands(player, ppPos, rangeKey) {
      const playerHands = (this.hands || []).filter(i => i.players[player].eq_percentile >= 0)
      let res = []
      res = playerHands.map((i, idx) => ({
        hand: i.id,
        x: i.players[player].eq_percentile,
        y: 1 - i.players[player].eq,
        eq: i.players[player].eq,
        ppPos,
        player,
        circle_size: i.players[player][rangeKey],
        rangeKey,
        orig_hand: i,
      }))
      res = res.sort((a, b) => {
        if (a.y === b.y) return a.x - b.x // if y is the same, sort by x othervise you get broken svg path in firefox - why to be continoued from @luXmelo
        return a.x < b.x ? -1 : 1
      })
      // BE can return the last value not 1
      if (res.length) {
        res[res.length - 1].x = 1
      }
      return res
    },
    getFilteredPoints(points, hands) {
      if (!hands?.length) return []
      return points.filter(i => hands.some(id => id === i.hand))
    },
  },
  computed: {
    playersPoints() {
      return this.players.map((player, index) =>
        this.getPlayerPoints(index, player.relative_postflop_position, this.rangeKey),
      )
    },
    pointsActiveXY() {
      const filteredPlayersPoints = this.playersPoints
        .map((points, index) => this.getFilteredPoints(points, this.activeHands[index]))
        .reduce((acc, points) => [...acc, ...points], [])

      return filteredPlayersPoints
    },
  },
}
export default eq_chart_mix
